import React from "react";
import styled from "styled-components";

const ScrollContainer = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  padding: 20px 25px;
  margin: 20px 0;
`;

const ImageStyled = styled.img`
  display: inline-block;
  max-width: none;
  height: auto;
  width: 950px;
`;

export const ScrollableImage = ({ src }) => (
  <ScrollContainer>
    <ImageStyled src={src} />
  </ScrollContainer>
);
